define('viewmodels/configuration/ClientDetails',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'viewmodels/GeneralSettings'], function (ko, router, appsecurity, navigation, app, logger, system, ObjGeneralSettings) {
    var title = 'ClientDetails';
    var isEdit = false;
    var tableObj = false;
    var CdViewModel = {
        activate: activate,
        title: title,
        attached: attached,
        detached: detached,
        ObjGeneralSettings: ObjGeneralSettings,
        ClientDetails: ko.observable(),
        ClientDetailsRevert: ko.observable(),
        logger: logger,
        popUpTitle: ko.observable(),
        appsecurity: appsecurity,
        addPopUpCss: ko.observable(true),
        editPopUpCss: ko.observable(true),
        saveButton: saveButton,
        cancelButton: cancelButton,
        validateDetails: validateDetails,
        alwaysTriggerAttach: true,
        editableContact: ko.observable(),
        savePopUpButton: savePopUpButton,
        ContactList: ko.observableArray(),
        addFunctionality: addFunctionality,
        editFunctionality: editFunctionality,
        deleteFunctionality: deleteFunctionality,
        ControlsAccess: ko.observable(false),
        currentYear: ko.observable(),
        changedYear: ko.observable(),
        UploadFileSize: ko.observable(1073741824),
        ProgressMessage: ko.observable(),
        //UploadDocumentsList: ko.observableArray(),
        //imagePath: ko.observable(),
        //imageCompletePath: ko.observable(''),
        updateClientdetails: updateClientdetails,
        //SetProfilePicture: SetProfilePicture,
        EditDetailsClick: EditDetailsClick,
        saveClientDetails: saveClientDetails,
        LocaleCheckFlag: ko.observable(false)
    };

    return CdViewModel;


    var GetClientDetailsAjax = {};
    var GetContactsAjax = {};
    var AddClientDetailsAjax = {};
    var UpdateClientDetailsAjax = {};

    function activate() {
        try {
            if (CdViewModel.ObjGeneralSettings === undefined || CdViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((CdViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || CdViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && CdViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                CdViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (CdViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || CdViewModel.ObjGeneralSettings.LocalizedTextList() == null || CdViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || CdViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || CdViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        CdViewModel.LocaleCheckFlag(false);
                    else
                        CdViewModel.LocaleCheckFlag(true);
                });
            } else
                CdViewModel.LocaleCheckFlag(true);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in ClientDetails.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(0)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in ClientDetails.js';
            logger.logMessage(msg);
        }
    };

    function EditDetailsClick(data, event) {
        try {
            var element = $("#client-detail-form-wrapper");
            element.toggle(500);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: EditDetailsClick() method in ClientDetails.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            $('#CdsaveButton').hide();
            $('#ResetButton').hide();
            if (appsecurity.isConfigurationFreeze() === undefined) {
                appsecurity.GetConfigurationFreezeFlag().then(function () {
                    if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                        CdViewModel.ControlsAccess(true);
                    }
                    else {
                        CdViewModel.ControlsAccess(false);
                    }
                });
            }
            else if (appsecurity.WriteAccess() && !appsecurity.isConfigurationFreeze()) {
                CdViewModel.ControlsAccess(true);
            }
            else {
                CdViewModel.ControlsAccess(false);
            }

            if (CdViewModel.ObjGeneralSettings === undefined || CdViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((CdViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || CdViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && CdViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                CdViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (CdViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || CdViewModel.ObjGeneralSettings.LocalizedTextList() == null || CdViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || CdViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || CdViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        CdViewModel.LocaleCheckFlag(false);
                    else
                        CdViewModel.LocaleCheckFlag(true);
                });
            }
            //CdViewModel.ControlsAccess(CdViewModel.appsecurity.WriteAccess());
            GetClientDetailsAjax = {
                url: "/api/Configuration/GetClientDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            getClientDetails(GetClientDetailsAjax);

           
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method from ClientDetails in ClientDetails.js';
            logger.logMessage(msg);
        }
    }

    function getClientDetails(GetClientDetailsAjax) {
        try {
            $.ajax(GetClientDetailsAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call method from getClientDetails in ClientDetails.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult.Incident_Description == null) {
                    if (jsonResult.Flag == 1) {
                        var CompletePath = '../../../../BankImages/';
                        jsonResult.ImageCompletePath = CompletePath + jsonResult.ImageCompletePath;
                        CdViewModel.ClientDetails(new clientDetailsModel(jsonResult));
                        CdViewModel.ClientDetailsRevert(new clientDetailsModel(jsonResult))
                        //GetProfilePictureDetails();
                        $('#CdsaveButton').text("Update");
                        $('#btnBankDetails').text("Update");
                        GetContactsAjax = {
                            url: "/api/Configuration/GetAllContacts?ClientId=" + CdViewModel.ClientDetails().ClientId(),
                            type: "GET",
                            headers: appsecurity.getSecurityHeaders()

                        };
                        getAllContacts(GetContactsAjax);

                    }
                    else if (jsonResult.Flag == 0) {
                        CdViewModel.ClientDetails(new clientDetailsModel(jsonResult));
                        CdViewModel.ClientDetailsRevert(new clientDetailsModel(jsonResult))
                        $('#CdsaveButton').text("Save");
                        $('#btnBankDetails').text("Save");
                    }
                }
                else {
                    if (jsonResult.Incident_Description != null) {
                        var msg = (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                        logger.logWarning(jsonResult.Incident_Description + " - " + msg, 'Error', system.getModuleId(CdViewModel), true);
                    }
                    else {
                        logger.logWarning((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Warning', system.getModuleId(CdViewModel), true);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method from getClientDetails in ClientDetails.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status, xhr) {
            try {
                if (error.status === 401) {
                    app.showMessage((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    logger.logMessage('Exception:' + error.statusText + ' exception in ajaxfail() of getClientDetails on ClientDetails.js');

                }
            }
            catch (e) {

                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method from getClientDetails in ClientDetails.js';
                logger.logMessage(msg);
            }
        }
    }

    function addClientDetails(AddClientDetailsAjax) {
        try {

            var updatedValue = {
                ClientId: CdViewModel.ClientDetails().ClientId(),
                ClientName: CdViewModel.ClientDetails().ClientName(),
                ShortName: CdViewModel.ClientDetails().ShortName(),
                HdqName: CdViewModel.ClientDetails().HdqName(),
                AddressLine1: CdViewModel.ClientDetails().AddressLine1(),
                AddressLine2: CdViewModel.ClientDetails().AddressLine2(),
                AddressLineCity: CdViewModel.ClientDetails().AddressCity(),
                AddressLineState: CdViewModel.ClientDetails().AddressState(),
                AddressCountry: CdViewModel.ClientDetails().AddressCountry(),
                AddressPostalCode: CdViewModel.ClientDetails().AddressPostalCode(),
                HeadName: CdViewModel.ClientDetails().HeadName(),
            };

            var resetValue = {
                ClientId: CdViewModel.ClientDetailsRevert().ClientId(),
                ClientName: CdViewModel.ClientDetailsRevert().ClientName(),
                ShortName: CdViewModel.ClientDetailsRevert().ShortName(),
                HdqName: CdViewModel.ClientDetailsRevert().HdqName(),
                AddressLine1: CdViewModel.ClientDetails().AddressLine1(),
                AddressLine2: CdViewModel.ClientDetails().AddressLine2(),
                AddressLineCity: CdViewModel.ClientDetails().AddressCity(),
                AddressLineState: CdViewModel.ClientDetails().AddressState(),
                AddressCountry: CdViewModel.ClientDetails().AddressCountry(),
                AddressPostalCode: CdViewModel.ClientDetails().AddressPostalCode(),
                HeadName: CdViewModel.ClientDetailsRevert().HeadName(),
            };

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addClientDetails() in ClientDetails.js';
            logger.logMessage(msg);
        }

        try {

            $.ajax(AddClientDetailsAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call method from addClientDetails in ClientDetails.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(result, status) {
            try {

                GetClientDetailsAjax = {
                    url: "/api/Configuration/GetClientDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                };



                getClientDetails(GetClientDetailsAjax);
                if (result == 1) {
                    $('#keyContactsTable').dataTable().fnDestroy();
                    $('#keyContactsTable tbody').empty();
                    CdViewModel.ClientDetails(new clientDetailsModel(result));
                    CdViewModel.ClientDetailsRevert(new clientDetailsModel(result));

                    GetContactsAjax = {
                        url: "/api/Configuration/GetAllContacts?ClientId=" + CdViewModel.ClientDetails().ClientId() + "&YearOfAssessment=0",
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders()
                    };
                    getAllContacts(GetContactsAjax);
                    logger.logSuccess((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterpriseInfoSuccessfully') == -1) ? 'Enterprise Information saved successfully.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterpriseInfoSuccessfully')].Name(), 'Success', system.getModuleId(CdViewModel), true);

                    $('#CdsaveButton').text("Update");
                }
                else if (result == 0) {
                    CdViewModel.ClientDetails(new clientDetailsModel(updatedValue));
                    logger.logError((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterpriseInformationfailed') == -1) ? 'Enterprise Information failed to save, for current profile. Please contact your Administrator.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterpriseInformationfailed')].Name(), 'Error', system.getModuleId(CdViewModel), true);

                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxsuccess() method from addClientDetails in ClientDetails.js';
                logger.logMessage(msg);
            }

        };

        function ajaxFail(error, status) {
            try {
                if (error.status === 401) {
                    app.showMessage((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception:' + error.statusText + 'exception | Source: ajaxfail() method from addClientDetails in ClientDetails.js';
                    logger.logMessage(msg);
                    CdViewModel.ClientDetails(new clientDetailsModel(resetValue));
                    logger.logWarning((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterpriseInformationAlreadypresent') == -1) ? 'Enterprise Information is already present with us. If you intend to update the same, please refresh the page and update the data.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterpriseInformationAlreadypresent')].Name(), 'Warning', system.getModuleId(CdViewModel), true);

                    $('#CdsaveButton').text("Save");
                }
            } catch (e) {
                var msg = 'Exception: ' + e + '| Source: ajaxfail() method from addClientDetails in ClientDetails.js';
                logger.logMessage(msg);
            }
        };
    };

    function updateClientdetails(UpdateClientDetailsAjax) {

        try {
            var updatedValue = {

                ClientId: CdViewModel.ClientDetails().ClientId(),
                ClientName: CdViewModel.ClientDetails().ClientName(),
                ShortName: CdViewModel.ClientDetails().ShortName(),
                HdqName: CdViewModel.ClientDetails().HdqName(),
                AddressLine1: CdViewModel.ClientDetails().AddressLine1(),
                AddressLine2: CdViewModel.ClientDetails().AddressLine2(),
                AddressLineCity: CdViewModel.ClientDetails().AddressCity(),
                AddressLineState: CdViewModel.ClientDetails().AddressState(),
                AddressCountry: CdViewModel.ClientDetails().AddressCountry(),
                AddressPostalCode: CdViewModel.ClientDetails().AddressPostalCode(),
                HeadName: CdViewModel.ClientDetails().HeadName(),
            };

            var resetValue = {
                ClientId: CdViewModel.ClientDetailsRevert().ClientId(),
                ClientName: CdViewModel.ClientDetailsRevert().ClientName(),
                ShortName: CdViewModel.ClientDetailsRevert().ShortName(),
                HdqName: CdViewModel.ClientDetailsRevert().HdqName(),
                AddressLine1: CdViewModel.ClientDetails().AddressLine1(),
                AddressLine2: CdViewModel.ClientDetails().AddressLine2(),
                AddressLineCity: CdViewModel.ClientDetails().AddressCity(),
                AddressLineState: CdViewModel.ClientDetails().AddressState(),
                AddressCountry: CdViewModel.ClientDetails().AddressCountry(),
                AddressPostalCode: CdViewModel.ClientDetails().AddressPostalCode(),
                HeadName: CdViewModel.ClientDetailsRevert().HeadName(),
            };
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: updateClientdetails() in ClientDetails.js';
            logger.logMessage(msg);
        }

        try {
            DataToBeSent = CdViewModel.ClientDetails();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/UpdateClientDetails?YearChanged=false",
                headers: headers,
                type: "POST",
                data: DataToBeSent
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call method from updateClientDetails in ClientDetails.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(result, status) {
            try {

                if (result == 1) {

                    $('#keyContactsTable').dataTable().fnDestroy();
                    $('#keyContactsTable tbody').empty();

                    CdViewModel.ClientDetailsRevert(new clientDetailsModel(updatedValue));
                    logger.logSuccess((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterpriseInfoSuccessfully') == -1) ? 'Enterprise Information saved successfully.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterpriseInfoSuccessfully')].Name(), 'Success', system.getModuleId(CdViewModel), true);

                    GetContactsAjax = {
                        url: "/api/Configuration/GetAllContacts?ClientId=" + CdViewModel.ClientDetails().ClientId(),
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders()

                    };
                    getAllContacts(GetContactsAjax);
                    $('#CdsaveButton').text("Update");

                }
                else if (result == 0) {
                    logger.logWarning((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterpriseInformationAlreadypresent') == -1) ? 'Enterprise Information is already present with us. If you intend to update the same, please refresh the page and update the data.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterpriseInformationAlreadypresent')].Name(), 'Warning', system.getModuleId(CdViewModel), true);

                    CdViewModel.ClientDetails(new clientDetailsModel(resetValue));
                    $('#CdsaveButton').text("Update");
                }
                else if (result == -1) {

                    logger.logError((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(CdViewModel), true);

                    CdViewModel.ClientDetails(new clientDetailsModel(resetValue));
                    $('#CdsaveButton').text("Update");
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method from updateClientDetails in ClientDetails.js';
                logger.logMessage(msg);
            }

        };

        function ajaxFail(error, status) {
            try {
                if (error.status === 401) {
                    app.showMessage((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception:' + error.statusText + ' | Source: ajaxfail() method from updateClientDetails in ClientDetails.js';
                    logger.logMessage(msg);
                    
                    CdViewModel.ClientDetails(new clientDetailsModel(resetValue));
                    $('#CdsaveButton').text("Update");
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxfail() method from updateClientDetails in ClientDetails.js';
                logger.logMessage(msg);
            }
        };

    };


    function validateDetails() {

        try {
            var validateStatus = 1;
            if ($('#txtClientName').val().length == 0 || $('#txtShortName').val().length == 0 || $('#txthdqName').val().length == 0 || $('#txtaddressState').val().length == 0 || $('#txtaddressCountry').val().length == 0 || $('#txtaddressPostalCode').val().length == 0) {
                validateStatus = 0;
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: validateDetails method in ClientDetails.js';
            logger.logMessage(msg);
        }
        return validateStatus;


    }

    function saveButton(data) {

        try {
            var validationResult = validateDetails();
            if (validationResult == 1) {
                $("#lblClientNameVal").hide();
                $("#lblShortNameVal").hide();
                $("#lblhdqNameVal").hide();
                $("#lbladdressVal").hide();
                if ($('#CdsaveButton').text() == "Save") {
                    DataToBeSent = data.ClientDetails();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    AddClientDetailsAjax = {
                        url: "/api/Configuration/AddClientDetails",
                        headers: headers,
                        type: "POST",
                        data: DataToBeSent
                    };
                    addClientDetails(AddClientDetailsAjax);

                }
                else if ($('#CdsaveButton').text() == "Update") {
                    DataToBeSent = data.ClientDetails();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    UpdateClientDetailsAjax = {
                        url: "/api/Configuration/UpdateClientDetails?YearChanged=false",
                        headers: headers,
                        type: "POST",
                        data: DataToBeSent
                    };
                    updateClientdetails(UpdateClientDetailsAjax);

                };
            }
            else {
                $("#lblClientNameVal").show();
                $("#lblShortNameVal").show();
                $("#lblhdqNameVal").show();
                $("#lbladdressVal").show();

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveButton method in ClientDetails.js';
            logger.logMessage(msg);
        }
    };

    function saveClientDetails(data, event) {
        try {
            var validationResult = validateDetails();
            if (validationResult == 0) {
                logger.logError((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('PleaseEnterClientDetails') == -1) ? 'Please enter all the values to save the Client Details.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('PleaseEnterClientDetails')].Name(), 'Error', system.getModuleId(CdViewModel), true);

            }
            if (validationResult == 1) {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                AddClientDetailsAjax = {
                    url: "/api/Configuration/AddClientDetails",
                    headers: headers,
                    type: "POST",
                    data: data
                };
                addClientDetails(AddClientDetailsAjax);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveClientDetails method in ClientDetails.js';
            logger.logMessage(msg);
        }
    }

    function cancelButton() {

        try {
            var buttonText = $('#CdsaveButton').text();
            var reset = {
                ClientId: CdViewModel.ClientDetailsRevert().ClientId(),
                ClientName: CdViewModel.ClientDetailsRevert().ClientName(),
                ShortName: CdViewModel.ClientDetailsRevert().ShortName(),
                HdqName: CdViewModel.ClientDetailsRevert().HdqName(),
                HeadName: CdViewModel.ClientDetailsRevert().HeadName(),
                AddressLine1: CdViewModel.ClientDetailsRevert().AddressLine1(),
                AddressLine2: CdViewModel.ClientDetailsRevert().AddressLine2(),
                AddressCity: CdViewModel.ClientDetailsRevert().AddressCity(),
                AddressState: CdViewModel.ClientDetailsRevert().AddressState(),
                AddressCountry: CdViewModel.ClientDetailsRevert().AddressCountry(),
                AddressPostalCode: CdViewModel.ClientDetailsRevert().AddressPostalCode(),
            };
            CdViewModel.ClientDetails(new clientDetailsModel(reset));
            $('#CdsaveButton').text(buttonText);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: cancelButton() method in ClientDetails.js';
            logger.logMessage(msg);
        }
    };

    function clientDetailsModel(item) {
        try {
            var self = this;
            self.ClientId = ko.observable(item.ClientId);
            self.ClientName = ko.observable($('<div/>').html(item.ClientName).text());
            self.ShortName = ko.observable($('<div/>').html(item.ShortName).text());
            self.HdqName = ko.observable($('<div/>').html(item.HdqName).text());
            self.AddressLine1 = ko.observable($('<div/>').html(item.AddressLine1).text());
            self.AddressLine2 = ko.observable($('<div/>').html(item.AddressLine2).text());
            self.AddressCity = ko.observable($('<div/>').html(item.AddressCity).text());
            self.AddressState = ko.observable($('<div/>').html(item.AddressState).text());
            self.AddressCountry = ko.observable($('<div/>').html(item.AddressCountry).text());
            self.AddressPostalCode = ko.observable(item.AddressPostalCode);
            self.HeadName = ko.observable($('<div/>').html(item.HeadName).text());
            self.ImageCompletePath = ko.observable($('<div/>').html(item.ImageCompletePath).text() + $('<div/>').html(item.imageName).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: clientDetailsModel() method in ClientDetails.js';
            logger.logMessage(msg);
        }
    };

    function contactDetails(item) {
        try {
            var self = this;
            self.ClientId = ko.observable(item.ClientId);
            self.Contact_Id = ko.observable(item.ContactId);
            self.Contact_Name = ko.observable($('<div/>').html(item.ContactName).text());
            self.Designation = ko.observable($('<div/>').html(item.Designation).text());
            self.Department = ko.observable($('<div/>').html(item.Department).text());
            self.Comments = ko.observable($('<div/>').html(item.Comments).text());
            self.Email = ko.observable($('<div/>').html(item.Email).text());
            self.Contact_Number = ko.observable(item.ContactNumber);
            self.TargetRow = ko.observable();
            self.PhoneNumberInTable = ko.observable(item.ContactNumber);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: contactDetails() method in ClientDetails.js';
            logger.logMessage(msg);
        }
    }

    function addFunctionality() {
        try {
            var newContact = new contactDetails({ ClientId: CdViewModel.ClientDetails().ClientId(), YearOfAssessment: 0, ContactId: 999, ContactName: "", Designation: "", Email: "", Department: "", Comments: "", ContactNumber: "" });
            CdViewModel.editableContact(newContact);
            CdViewModel.popUpTitle((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddNewContact') == -1) ? 'Add New Contact' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddNewContact')].Name());
            CdViewModel.addPopUpCss(true);
            CdViewModel.editPopUpCss(false);
            $('#frmKeyContacts').modal('show');
            $("#ContactPhoneNumber").intlTelInput({
                allowExtensions: true,
                autoFormat: false,
                autoHideDialCode: false,
                autoPlaceholder: false,
                defaultCountry: "auto",
                ipinfoToken: "yolo",
                nationalMode: false,
                numberType: "MOBILE",
                preventInvalidNumbers: true,
            });
            isEdit = false;

            setTimeout("$('#contactname').focus();", 200);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addFunctionality() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    };

    function savePopUpButton(data, event) {
        try {
            $('#valError').hide();
            var duplicateCheck = 0;
            for (var i = 0, j = CdViewModel.ContactList().length; i < j; i++) {
                if ((data.Contact_Name().toUpperCase() == CdViewModel.ContactList()[i].Contact_Name().toUpperCase()) && (data.TargetRow() != i))
                    duplicateCheck++;
            }
            if (data.Contact_Name() == "") {
                $('#valError').show();
                $('#valError').text((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NameRequired') == -1) ? 'Contact name is required.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NameRequired')].Name());
            }
            else if (data.Contact_Name().length > 50) {
                $('#valError').show();
                $('#valError').text((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantackName50chars') == -1) ? 'Contact name cannot exceed 50 characters.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantackName50chars')].Name());

            }
            else if (data.Designation() == "") {
                $('#valError').show();
                $('#valError').text((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DesignationRequired') == -1) ? 'Designation is required.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DesignationRequired')].Name());
            }
            else if (data.Designation().length > 100) {
                $('#valError').show();
                $('#valError').text((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Designation100characters') == -1) ? 'Designation cannot exceed 100 characters.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Designation100characters')].Name());
            }
            else if (data.Department() == "") {
                $('#valError').show();
                $('#valError').text((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DepartmentRequired') == -1) ? 'Department is required.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DepartmentRequired')].Name());
            }
            else if (data.Email() == "") {
                $('#valError').show();
                $('#valError').text((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EmailRequired') == -1) ? 'Email is required.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EmailRequired')].Name());

            }
            else if (!validateEmail(data.Email())) {
                $('#valError').show();
                $('#valError').text((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidEmail') == -1) ? 'Invalid Email.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidEmail')].Name());

            }
            else if (!($("#ContactPhoneNumber").intlTelInput("isValidNumber"))) {
                $('#valError').show();
                $('#valError').text((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('entervalidcontact') == -1) ? 'Please enter a valid contact number.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('entervalidcontact')].Name());

            }
            var error = $('#valError').is(':hidden');
            if (error) {
                if (!isEdit) {
                    if (duplicateCheck == 1) {
                        $('#valError').show();
                        $('#valError').text(data.Contact_Name() + ' ' + (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexitscontactname') == -1) ? 'already exists. Please enter a different Contact Name.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexitscontactname')].Name());
                    }
                    else {
                        var Countrycode = "+" + $("#ContactPhoneNumber").intlTelInput("getSelectedCountryData").dialCode;
                        var number = $("#ContactPhoneNumber").intlTelInput("getNumber");
                        number = number.substring(Countrycode.length, number.length);
                        data.Contact_Number(Countrycode + "-" + number)
                        addContact(data);
                        $('#frmKeyContacts').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }
                }
                else {
                    if (duplicateCheck == 1) {
                        $('#valError').show();
                        $('#valError').text(data.Contact_Name() + ' ' + (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexitscontactname') == -1) ? 'already exists. Please enter a different Contact Name.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexitscontactname')].Name());
                    }
                    else {
                        var Countrycode = "+" + $("#ContactPhoneNumber").intlTelInput("getSelectedCountryData").dialCode;
                        var number = $("#ContactPhoneNumber").intlTelInput("getNumber");
                        number = number.substring(Countrycode.length, number.length);
                        data.Contact_Number(Countrycode + "-" + number)
                        editContact(data);
                        $('#frmKeyContacts').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }
                }
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: savePopUpButton() method in ClientDetails.js';
            logger.logMessage(msg);
        }
    };
    // Function that validates email address through a regular expression.
    function validateEmail(sEmail) {
        try {
            var filter = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;
            if (filter.test(sEmail)) {
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: validateEmail() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    };

    function phonenumber(inputtxt) {
        try {
            var phoneno = /^(?=.*?[1-9])[0-9()-/+ ]+$/;
            if (inputtxt.match(phoneno)) {
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: phonenumber() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }

    function IsValidZipCode(zip) {
        try {
            var isValid = /^[0-9]{5}(?:-[0-9]{4})?$/.test(zip);
            if (isValid) return true;
            else { return false; }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: IsValidZipCode() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }


    //getting contacts
    function getAllContacts(options) {
        try {
            $.ajax(options)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in getAllBusinessUnits() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResultObj, status) {

            try {
                tableObj = $('#keyContactsTable').DataTable();
                var p = tableObj.page.info().page
                tableObj.destroy();
                $("#keyContactsTable tbody tr").remove();
                var mappedContacts = $.map(jsonResultObj, function (result) {
                    return new contactDetails(result);
                });

                CdViewModel.ContactList(mappedContacts);


                tableObj = $('#keyContactsTable').DataTable({
                    responsive: true,

                    'iDisplayLength': 5,
                    'bLengthChange': false,
                    'bFilter': false,
                    "aoColumnDefs": [{
                        "aTargets": [0],
                        "bVisible": false
                    },
                    {
                        "aTargets": [4],
                        "bSortable": false
                    },
                    {
                        "aTargets": [5],
                        "bSortable": false
                    },
                    {
                        "aTargets": [6],
                        "bSortable": false
                    },
                    {
                        "aTargets": [7],
                        "bSortable": false,
                        "bVisible": (CdViewModel.ControlsAccess()) ? true : false,
                        "sClass": "text-center"
                    }]



                });
                tableObj.page(p).draw(false);


            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in getAllContacts() method in ClientDetails.js';
                logger.logMessage(msg);
            }

        };

        function ajaxFail(error, status) {
            try {

                if (error.status === 401) {
                    app.showMessage((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    logger.logMessage('Exception:' + error.statusText + ' exception in ajaxfail() of getAllContacts on ClientDetails.js');

                }
            }
            catch (e) {

                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method from getAllContacts in ClientDetails.js';
                logger.logMessage(msg);
            }
        };

    };


    //adding contact

    function addContact(data) {

        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/AddContact",
                headers: headers,
                type: "POST",
                data: { ClientId: data.ClientId(), ContactName: data.Contact_Name(), Designation: data.Designation(), Email: data.Email(), ContactNumber: data.Contact_Number(), Comments: data.Comments(), Department: data.Department() }

            }).success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in addContact() method in ClientDetails.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {

            try {


                if (jsonResult != null)
                {
                    if (jsonResult.Flag == 1)
                    {
                        GetContactsAjax = {
                            url: "/api/Configuration/GetAllContacts?ClientId=" + CdViewModel.ClientDetails().ClientId() + "&YearOfAssessment=0",
                            type: "GET",
                            headers: appsecurity.getSecurityHeaders()
                        };
                        getAllContacts(GetContactsAjax);

                        logger.logSuccess((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Contactaddedsuccessfully') == -1) ? 'Contact added successfully.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Contactaddedsuccessfully')].Name(), 'Success', system.getModuleId(CdViewModel), true);
                    }
                    else
                    {
                        var msg = (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Failedaddcontact') == -1) ? 'Failed to add contact.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Failedaddcontact')].Name();
                        logger.logError(jsonResult.Comments + " - " + msg, 'Error', system.getModuleId(CdViewModel), true);
                    }
                }
                else {
                    var msg = (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Failedaddcontact') == -1) ? 'Failed to add contact.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Failedaddcontact')].Name();
                    logger.logError(msg, 'Error', system.getModuleId(CdViewModel), true);

                };


            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in addContact() method in ClientDetails.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {

            try {
                if (error.status === 401) {
                    app.showMessage((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in addContact() method in ClientDetails.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in addContact() method in ClientDetails.js';
                logger.logMessage(msg);
            }

        };
    };


    function editFunctionality(data, event) {
        try {
            var selectedRow = $(event.currentTarget).closest("tr").get(0);
            data.TargetRow(selectedRow._DT_RowIndex);
            var newObservable = new contactDetails({ ClientId: CdViewModel.ClientDetails().ClientId(), YearOfAssessment: 0, ContactId: data.Contact_Id(), ContactName: data.Contact_Name(), Designation: data.Designation(), Department: data.Department(), Email: data.Email(), ContactNumber: data.Contact_Number(), Comments: data.Comments() });
            newObservable.TargetRow(selectedRow._DT_RowIndex);
            CdViewModel.editableContact(newObservable);
            CdViewModel.popUpTitle((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditContactDetails') == -1) ? 'Edit Contact Details' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditContactDetails')].Name());
            CdViewModel.addPopUpCss(false);
            CdViewModel.editPopUpCss(true);
            $('#frmKeyContacts').modal('show');
            isEdit = true;

            $("#ContactPhoneNumber").intlTelInput({
                allowExtensions: true,
                autoFormat: false,
                autoHideDialCode: false,
                autoPlaceholder: false,
                defaultCountry: "auto",
                ipinfoToken: "yolo",
                nationalMode: false,
                numberType: "MOBILE",
                preventInvalidNumbers: true,
            });
            setTimeout("$('#contactname').focus();", 200);

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: editFunctionality() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    };


    function deleteFunctionality(data, event) {
        try {
            app.showMessage((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SuretoDeleteContact') == -1) ? 'Are you sure you want to delete this Contact?' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SuretoDeleteContact')].Name, (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteContact') == -1) ? 'Delete Contact' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteContact')].Name, [(!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name, (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name])
                .then(function (option) {
                    var confirmText = ((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                    if (option === confirmText) {
                        deleteContact(data, event);
                    }
                });
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: deleteFunctionality() method in ClientDetails.js';
            logger.logMessage(msg);
        }
    };

    function editContact(data) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/UpdateContact",
                headers: headers,
                type: "POST",
                data: { ClientId: data.ClientId(), ContactId: data.Contact_Id(), ContactName: data.Contact_Name(), Designation: data.Designation(), Email: data.Email(), ContactNumber: data.Contact_Number(), Comments: data.Comments(), Department: data.Department() }
            }).success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in editContact() method in ClientDetails.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {

            try {
                var code = jsonResult.slice(0, 1);
                var negative_code = jsonResult.slice(0, 2);
                var inc = jsonResult.slice(1, 11);
                var negative_inc = jsonResult.slice(2, 11);

                if (jsonResult != null) {
                    if (jsonResult == '1')
                    {
                        GetContactsAjax = {
                            url: "/api/Configuration/GetAllContacts?ClientId=" + CdViewModel.ClientDetails().ClientId() + "&YearOfAssessment=0",
                            type: "GET",
                            headers: appsecurity.getSecurityHeaders()
                        };
                        getAllContacts(GetContactsAjax);

                        logger.logSuccess((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactUpdatedsuccessfully') == -1) ? 'Contact updated successfully.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactUpdatedsuccessfully')].Name(), 'Success', system.getModuleId(CdViewModel), true);

                    }
                    else if (code == '0') {
                        var msg = (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoSuchContactExists') == -1) ? 'No such contact exists. Please refresh the page and peform the edit operation.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoSuchContactExists')].Name();
                        logger.logWarning(msg, 'Warning', system.getModuleId(CdViewModel), true);

                    }
                    else if (negative_code == '-1') {
                        //logger.logError((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SomeErrorOccurred') == -1) ? 'Some error occurred. Please refresh the page again and perform the edit operation.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SomeErrorOccurred')].Name(), 'Error', system.getModuleId(CdViewModel), true);

                        var msg = (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SomeErrorOccurred') == -1) ? 'Failed to update the Contact Details.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SomeErrorOccurred')].Name();
                        logger.logError(negative_inc + ' - ' + msg, 'Error', system.getModuleId(CdViewModel), true);
                    }

                    else {
                        var msg = (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                        logger.logError(jsonResult + ' - ' + msg, 'Error', system.getModuleId(CdViewModel), true);
                    }
                }
                else
                {
                    var msg = (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                    logger.logError(msg, 'Error', system.getModuleId(CdViewModel), true);
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in editContact() method in ClientDetails.js';
                logger.logMessage(msg);
            }
        }


        function ajaxFail(error, status) {

            try {
                if (error.status === 401) {
                    app.showMessage((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                navigation.unauthorized();
                        });
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in editContact() method in ClientDetails.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in editContact() method in ClientDetails.js';
                logger.logMessage(msg);
            }
        }
    }

    function deleteContact(data, event) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/DeleteContact",

                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    ClientId: data.ClientId(), ContactId: data.Contact_Id()
                }),
                headers: headers,
                type: "POST"
            }).success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in deleteContact() method in ClientDetails.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                var code = jsonResult.slice(0, 1);
                var negative_code = jsonResult.slice(0, 2);
                var inc = jsonResult.slice(1, 11);
                var negative_inc = jsonResult.slice(2, 11);

                if (jsonResult != null) {
                    if (jsonResult == '1') {

                        var targetRow = $(event.currentTarget).closest("tr").get(0);
                        data.TargetRow(targetRow._DT_RowIndex);
                        tableObj.row(targetRow).remove().draw(false);
                        CdViewModel.ContactList.splice(data.TargetRow(), 1);
                        logger.logSuccess((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Contactdeletedsuccessfully') == -1) ? 'Contact deleted successfully.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Contactdeletedsuccessfully')].Name(), 'Success', system.getModuleId(CdViewModel), true);
                    }
                    else if (code == '0') {
                        var msg = (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoContactExits') == -1) ? 'No such contact exists.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoContactExits')].Name();
                        logger.logError(msg, 'Warning', system.getModuleId(CdViewModel), true);
                    }
                    else if (negative_code == '-1') {
                        var msg = (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SomeErrorOccurredAdmin') == -1) ? 'An error occurred. Please try again or contact the Administrator.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SomeErrorOccurredAdmin')].Name();
                        logger.logError(negative_inc + ' - ' + msg, 'Error', system.getModuleId(CdViewModel), true);
                    }
                    else {
                        var msg = (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                        logger.logError(jsonResult + ' - ' + msg, 'Error', system.getModuleId(CdViewModel), true);
                    }

                }
                else {
                        var msg = (!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                        logger.logError(msg, 'Error', system.getModuleId(CdViewModel), true);
                  }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in deleteContact() method in ClientDetails.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status === 401) {
                    app.showMessage((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!CdViewModel.LocaleCheckFlag() || CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : CdViewModel.ObjGeneralSettings.LocalizedTextList()[CdViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in deleteContact() method in ClientDetails.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in deleteContact() method in ClientDetails.js';
                logger.logMessage(msg);
            }
        }
    }
});
